import { AutogenLayoutWireCodeForWireFundsLookup } from "./autogen/AutogenLayoutWireCodeForWireFundsLookup";

export class WireCodeForWireFundsLookup extends AutogenLayoutWireCodeForWireFundsLookup {
}
